<template>
  <Dialog ref="resetPassword">
    <template #expander="{ openModal }">
      <button type="button" @click="open" class="ue-link">Send reset password email</button>
    </template>
    <template #dialog.title>Warning</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <div class="reset-password-form">
        <div class="confirmation-text">
          Are you sure you want to reset {{ firstname }} {{ lastname }}'s password?
        </div>
        <div class="form-buttons">
          <ButtonCustomized label="Cancel" @click="closeModal" ctaSecondary />
          <ButtonCustomized label="Continue" cta @click="onSave" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from '@/components/Dialog/Dialog.vue';
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import { ref } from 'vue';

const emit = defineEmits(['cancel', 'save', 'open', 'fail'])
const resetPassword = ref()
defineProps(['firstname', 'lastname'])
function onSave() {
  emit('save');
  resetPassword.value.closeModal()
}
function open() {
  emit('open')
  resetPassword.value.openModal()
}
</script>

<style lang="scss" scoped>
.ue-link {
  display: inline-block;
  padding: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  color: var(--bui-tbl-row-link, #4b1886);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.reset-password-form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}

.confirmation-text {
  color: var(--bui-tbl-row-text, #2a2969);
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
